import { bannerConstants } from "../_constants";
import * as commonAction from "./commonAction";
import { commonService } from "../_services";
import { alertActions } from ".";
import { history } from "../_helpers";
import { apiConstants } from "../_constants/api.constants";

export const bannersActions = {
  saveBanner,
  getBannersList,
  deleteBanners
};

//-- Login function
function saveBanner(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(bannerConstants.BANNER_ADDED_REQUEST, catObj));
    commonService.withTokenPut(apiName, catObj).then(
      bannerData => {
        dispatch(commonAction.success(bannerConstants.BANNER_ADDED_SUCCESS, bannerData));
      },
      error => {
        dispatch(commonAction.failure(bannerConstants.BANNER_ADDED_FAILURE, error));
        // dispatch(alertActions.error(error.response.data.error));
      }
    );
  };
}

//-- getBannersList
function getBannersList(apiName, bannerData) {

  return dispatch => {

      dispatch(
          commonAction.request(bannerConstants.BANNER_LIST_REQUEST, bannerData)
      );
      commonService.withTokenPut(apiName, bannerData).then(
          notification => {

              dispatch(
                  commonAction.success(bannerConstants.BANNER_LIST_SUCCESS, notification)
              );
          },
          error => {
              dispatch(
                  commonAction.failure(bannerConstants.BANNER_LIST_ERROR, error)
              );
              dispatch(alertActions.error(error.response.data.error));
          }
      );
  };
}




//delete category
function deleteBanners(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(bannerConstants.BANNER_DELETE_REQUEST, catObj));
    commonService.withTokenPut(apiName, catObj).then(
      bannerData => {
        dispatch(commonAction.success(bannerConstants.BANNER_DELETE_SUCCESS, bannerData));
      },
      error => {
        dispatch(commonAction.failure(bannerConstants.BANNER_DELETE_FAILURE, error));
      }
    );
  };
}